import { z } from "zod";

export const audioFileMetadataSchema = z.object({
    durationInSeconds: z.number(),
});

export type AudioFileMetadata = z.infer<typeof audioFileMetadataSchema>;
